export class Constante {
    descripcion: string;
    minimo: string;
    maximo: string;
    medida: string;
    tomas: any[];
}



// WEBPACK FOOTER //
// ./src/models/constante.ts